module.exports = __webpack_public_path__ + "img/Frame 1041two.05b0d197.png";